export const getEmptyObjectKey = (object) => {
  return Object?.keys(object)?.map((key) => [key, object[key]])?.find(obj => !obj[1] || obj[1] === null)[0] || ''
}
export const getEmptyObjectKeys = (object) => {
  return Object?.keys(object)?.map((key) => [key, object[key]])?.filter(obj => !obj[1] || obj[1] === null)?.map(obj =>obj[0]) || []
}